
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 40 38","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 24.05h13.34v13.34h3V21.05H0zm22.69 13.34h3V24.05h13.34v-3H22.69zm-9.35-24.05H0v3h16.34V0h-3zm12.35 0V0h-3v16.34h16.34v-3z","fill":"#FFF"}})])
          )
        }
      }
    